export default __webpack_public_path__ + "static/media/Minicard_4d.1721a00e.svg";